var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTempBarcode(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 82,
    viewBox: "0 0 160 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2703_27129)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.45929 0H0V78.7116H3.45929V0Z",
    fill: "#070B0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.92049 0H4.75781V78.7116H6.92049V0Z",
    fill: "#070B0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.684 0H152.225V78.7116H155.684V0Z",
    fill: "#070B0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.091 0H156.74V78.7116H158.091V0Z",
    fill: "#070B0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.001 0H159.156V78.7116H160.001V0Z",
    fill: "#070B0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4263 0H9.51367V67.4888H11.4263V0Z",
    fill: "#070B0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4812 0H13.0449V67.4888H17.4812V0Z",
    fill: "#070B0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2901 0H18.8809V67.4888H20.2901V0Z",
    fill: "#070B0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5566 0H21.5879V67.4888H22.5566V0Z",
    fill: "#070B0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6227 0H33.957V67.4888H34.6227V0Z",
    fill: "#070B0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9474 0H35.7402V67.4888H36.9474V0Z",
    fill: "#070B0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8299 0H25.3164V67.4888H26.8299V0Z",
    fill: "#070B0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.1817 0H29.7754V67.4888H33.1817V0Z",
    fill: "#070B0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5714 0H38.9219V67.4888H41.5714V0Z",
    fill: "#070B0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.9594 0H43.8125V67.4888H49.9594V0Z",
    fill: "#070B0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.8528 0H51.9004V67.4888H53.8528V0Z",
    fill: "#070B0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.9953 0H55.6523V67.4888H56.9953V0Z",
    fill: "#070B0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.0486 0H67.5469V67.4888H68.0486V0Z",
    fill: "#070B0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.7961 0H68.8887V67.4888H69.7961V0Z",
    fill: "#070B0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.102 0H58.0039V67.4888H60.102V0Z",
    fill: "#070B0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.342 0H134.195V67.4888H140.342V0Z",
    fill: "#070B0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.238 0H142.285V67.4888H144.238V0Z",
    fill: "#070B0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.378 0H146.035V67.4888H147.378V0Z",
    fill: "#070B0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.487 0H148.391V67.4888H150.487V0Z",
    fill: "#070B0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.4521 0H62.8887V67.4888H65.4521V0Z",
    fill: "#070B0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.5109 0H77.5488V67.4888H78.5109V0Z",
    fill: "#070B0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.2799 0H88.6191V67.4888H89.2799V0Z",
    fill: "#070B0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.2577 0H92.7227V67.4888H94.2577V0Z",
    fill: "#070B0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.8687 0H80.125V67.4888H81.8687V0Z",
    fill: "#070B0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.4277 0H71.5078V67.4888H76.4277V0Z",
    fill: "#070B0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.251 0H84.7207V67.4888H87.251V0Z",
    fill: "#070B0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.5076 0H95.6875V67.4888H98.5076V0Z",
    fill: "#070B0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.045 0H101.105V67.4888H103.045V0Z",
    fill: "#070B0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.015 0H118.291V67.4888H119.015V0Z",
    fill: "#070B0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.517 0H121.205V67.4888H122.517V0Z",
    fill: "#070B0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.745 0H124.021V67.4888H124.745V0Z",
    fill: "#070B0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.467 0H126.924V67.4888H127.467V0Z",
    fill: "#070B0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.133 0H129.1V67.4888H132.133V0Z",
    fill: "#070B0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.538 0H104.508V67.4888H107.538V0Z",
    fill: "#070B0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.263 0H111.561V67.4888H115.263V0Z",
    fill: "#070B0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1079 81.7878V78.3801H12.2988V77.2629L17.8761 69.2739H19.7026V77.0508H21.4529V78.3784H19.7026V81.7862H18.1063L18.1079 81.7878ZM18.1079 77.0524V72.8756C18.1079 72.2209 18.1278 71.5662 18.1659 70.9115H18.1079C17.7237 71.6424 17.4157 72.1811 17.0696 72.7596L14.0111 77.0143V77.0524H18.1079Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.9759 75.3986C32.9759 79.6533 31.3995 82.002 28.6291 82.002C26.1865 82.002 24.5322 79.7114 24.4941 75.5727C24.4941 71.3759 26.3024 69.0654 28.841 69.0654C31.3796 69.0654 32.9759 71.4141 32.9759 75.3986ZM26.1865 75.5909C26.1865 78.8445 27.1867 80.6926 28.7251 80.6926C30.4556 80.6926 31.2836 78.6705 31.2836 75.4749C31.2836 72.2793 30.4953 70.3732 28.745 70.3732C27.2646 70.3732 26.1865 72.1831 26.1865 75.5909Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.1287 70.8554H40.0906L37.918 72.0289L37.5918 70.7394L40.3225 69.2759H41.7648V81.7881H40.1304V70.8538L40.1287 70.8554Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.0912 78.6122C48.0912 77.0343 49.0334 75.9171 50.5718 75.2624L50.5519 75.2044C49.1676 74.5497 48.5714 73.4723 48.5714 72.3933C48.5714 70.411 50.2439 69.0635 52.4364 69.0635C54.8591 69.0635 56.0712 70.585 56.0712 72.1431C56.0712 73.2022 55.5513 74.3375 54.0129 75.0685V75.1265C55.5711 75.7431 56.5316 76.8403 56.5316 78.3602C56.5316 80.5348 54.6653 81.9984 52.2808 81.9984C49.6644 81.9984 48.0879 80.4387 48.0879 78.6105L48.0912 78.6122ZM54.8227 78.5359C54.8227 77.016 53.7645 76.2834 52.0721 75.8027C50.6099 76.2271 49.8217 77.1884 49.8217 78.3818C49.7637 79.6514 50.7258 80.7685 52.3222 80.7685C53.9185 80.7685 54.8227 79.8254 54.8227 78.5359ZM50.1678 72.279C50.1678 73.5304 51.11 74.2033 52.5523 74.5895C53.6287 74.2232 54.4567 73.4541 54.4567 72.3187C54.4567 71.3176 53.8605 70.2784 52.342 70.2784C50.9378 70.2784 50.1694 71.2016 50.1694 72.2806L50.1678 72.279Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.7088 70.855H63.6707L61.4981 72.0285L61.1719 70.7389L63.9025 69.2754H65.3449V81.7876H63.7105V70.8533L63.7088 70.855Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.9384 69.2754V70.3925L80.4953 81.7893H78.7449L84.1682 70.7207V70.6826H78.0527V69.277H85.9384V69.2754Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.9213 75.3986C97.9213 79.6533 96.3448 82.002 93.5744 82.002C91.1318 82.002 89.4775 79.7114 89.4395 75.5727C89.4395 71.3759 91.2478 69.0654 93.7863 69.0654C96.3249 69.0654 97.9213 71.4141 97.9213 75.3986ZM91.1318 75.5909C91.1318 78.8445 92.132 80.6926 93.6704 80.6926C95.4009 80.6926 96.2289 78.6705 96.2289 75.4749C96.2289 72.2793 95.4406 70.3732 93.6903 70.3732C92.2099 70.3732 91.1318 72.1831 91.1318 75.5909Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.71 75.3981C109.71 79.6529 108.134 82.0015 105.363 82.0015C102.921 82.0015 101.267 79.7109 101.229 75.5722C101.229 71.3755 103.037 69.0649 105.575 69.0649C108.114 69.0649 109.71 71.4136 109.71 75.3981ZM102.921 75.5904C102.921 78.844 103.921 80.6921 105.459 80.6921C107.19 80.6921 108.018 78.67 108.018 75.4744C108.018 72.2788 107.23 70.3727 105.479 70.3727C103.999 70.3727 102.921 72.1826 102.921 75.5904Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.173 80.5945C114.539 80.6326 114.962 80.5945 115.538 80.5365C116.518 80.4022 117.442 79.9978 118.154 79.3232C118.981 78.5724 119.577 77.4751 119.809 75.9934H119.751C119.058 76.8403 118.058 77.3409 116.808 77.3409C114.558 77.3409 113.115 75.6469 113.115 73.5105C113.115 71.1419 114.827 69.0635 117.384 69.0635C119.941 69.0635 121.519 71.1419 121.519 74.3375C121.519 77.0906 120.595 79.0149 119.365 80.2083C118.403 81.1514 117.076 81.7299 115.73 81.884C115.114 81.9801 114.576 82 114.172 81.9801V80.5945H114.173ZM114.788 73.3944C114.788 74.9541 115.73 76.0514 117.192 76.0514C118.327 76.0514 119.212 75.4928 119.655 74.742C119.751 74.5878 119.809 74.3956 119.809 74.1254C119.809 71.9889 119.02 70.353 117.25 70.353C115.808 70.353 114.788 71.6243 114.788 73.3944Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.828 78.6122C124.828 77.0343 125.77 75.9171 127.308 75.2624L127.288 75.2044C125.904 74.5497 125.308 73.4723 125.308 72.3933C125.308 70.411 126.98 69.0635 129.173 69.0635C131.595 69.0635 132.808 70.585 132.808 72.1431C132.808 73.2022 132.288 74.3375 130.749 75.0685V75.1265C132.307 75.7431 133.268 76.8403 133.268 78.3602C133.268 80.5348 131.402 81.9984 129.017 81.9984C126.402 81.9984 124.824 80.4387 124.824 78.6105L124.828 78.6122ZM131.559 78.5359C131.559 77.016 130.501 76.2834 128.808 75.8027C127.346 76.2271 126.558 77.1884 126.558 78.3818C126.5 79.6514 127.462 80.7685 129.058 80.7685C130.655 80.7685 131.559 79.8254 131.559 78.5359ZM126.904 72.279C126.904 73.5304 127.846 74.2033 129.289 74.5895C130.367 74.2232 131.193 73.4541 131.193 72.3187C131.193 71.3176 130.597 70.2784 129.077 70.2784C127.672 70.2784 126.904 71.2016 126.904 72.2806V72.279Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.77 81.7879V80.7486L138.096 79.4591C141.289 76.4177 142.731 74.8 142.751 72.9138C142.751 71.6425 142.135 70.469 140.27 70.469C139.136 70.469 138.194 71.0458 137.616 71.5281L137.078 70.3348C137.944 69.6038 139.174 69.0635 140.616 69.0635C143.309 69.0635 144.443 70.9116 144.443 72.7016C144.443 75.0121 142.771 76.8784 140.136 79.4193L139.136 80.3426V80.3807H144.751V81.7862H136.77V81.7879Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2703_27129"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 160,
    height: 82,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTempBarcode);
export default __webpack_public_path__ + "static/media/temp-barcode.d2086de8b8e130ef855d2287568281a3.svg";
export { ForwardRef as ReactComponent };